import { useTranslation } from 'react-i18next';

/** A translator typed as a plain string function; see useAppTranslation. */
export type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

/**
 * `useTranslation()` with `t` typed as a plain string function.
 *
 * With TypeScript 4.9 and i18next 25, the typed-key overloads of `t` collapse
 * to a zero-argument signature inside a file that also instantiates React
 * Query's generics, and the CRA build (the only checker that reaches semantic
 * diagnostics in this project) then rejects every `t()` call in that file with
 * "Expected 0 arguments, but got 1". Components that pair translations with
 * `useQuery` / `useMutation` use this hook instead; the keys stay the same and
 * still resolve at runtime from the same resources.
 */
export function useAppTranslation() {
  const { t, i18n, ready } = useTranslation();
  return { t: t as unknown as TranslateFn, i18n, ready };
}
